/**
 * Aloká — Mega Menu Hover-to-Open
 * Desktop only (≥ 990px): opens <details class="mega-menu"> on mouseenter,
 * closes on mouseleave with a short delay to prevent flicker.
 */
(function () {
  const CLOSE_DELAY = 150; // ms before closing after cursor leaves
  const DESKTOP_BREAKPOINT = 990;

  function initHoverMenus() {
    if (window.innerWidth < DESKTOP_BREAKPOINT) return;

    const nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    const menus = nav.querySelectorAll('details.mega-menu');

    menus.forEach(function (details) {
      let closeTimer = null;

      details.addEventListener('mouseenter', function () {
        if (window.innerWidth < DESKTOP_BREAKPOINT) return;

        // Cancel any pending close
        clearTimeout(closeTimer);

        // Close all sibling mega menus first
        menus.forEach(function (other) {
          if (other !== details && other.hasAttribute('open')) {
            other.removeAttribute('open');
          }
        });

        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', function () {
        if (window.innerWidth < DESKTOP_BREAKPOINT) return;

        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, CLOSE_DELAY);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }
})();
